const taxesUrl = '/taxes';
const accountingCodesUrl = 'accounting-codes';
const settingsAccountingCodesUrl = '/settings/accounting-charts';

/**
 *
 * @returns {Promise | Promise<Object>}
 * return object for accounting code settings
 */
function getSettingsAccountingCodes() {
    return ApiClient.get("/settings/accounting-charts");
}

/**
 *
 * @returns {Promise<Array>}
 * Return array of taxes with accounting code
 */
function getTaxesWithAccountingCodes(params = {order: "rank"}) {
    return ApiClient.get(`${ taxesUrl }/accounting-codes`, params).then((response) => {
        return response.data.data;
    });
}

/**
 *
 * @param taxe
 * @param id
 * @returns {Promise | Promise<unknown>}
 */
function updateTaxesWithAccountingCodes(taxe, id) {
    return ApiClient.put(`${ taxesUrl }/${ id }/accounting-codes`, {}, taxe).then((response) => {
        return response.data
    });
}

/**
 *
 * @returns {Promise<*>}
 */
async function getListAccountingCodesForVat() {
    let result = await ApiClient.get(accountingCodesUrl, {limit: 100, order: 'code'});
    const accountingCodes = result.data.data;
    while (accountingCodes.length < result.data.pagination.total) {
        result = await ApiClient.get(accountingCodesUrl, {limit: 100, order: 'code', offset: result.data.pagination.offset});
        accountingCodes.push(...result.data.data);
    }
    return accountingCodes
}
/**
 * Return a specific accounting codes by its type (third, purchase, sell, bank or reconciliation)
 * @param filter : the looking type (string)
 * @param offset : offset by default 0 (number)
 * @returns {Promise<*>}
 */
function searchAccountingCodesPerType(filter, offset = 0, order = 'code'){
    filter = Array.isArray(filter) ? filter : [filter];

    return new Promise((resolve, reject) => {
        ApiClient.post("/accounting-codes/search", { offset, limit: 100, order }, { filters : { views : filter } }).then((res) => {
           resolve(res.data);
        }).catch((err) => {
           reject(err);
        })
    })
}

/**
 * call api to update data and return it.
 * @param params : params (object)
 * @param data : new data to update (object)
 * @returns {Promise<*>}
 */
function putSettingsAccountingCharts(params = {}, data){
    return ApiClient.put("/settings/accounting-charts", params, data);
}

export default {
    getSettingsAccountingCodes,
    getTaxesWithAccountingCodes,
    updateTaxesWithAccountingCodes,
    getListAccountingCodes: getListAccountingCodesForVat,
    searchAccountingCodesPerType,
    putSettingsAccountingCharts

};